module.exports = __webpack_public_path__ + "static/6-c05b41cd77efa9d57eb7599cea861a88.jpeg";